import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';
import { createLx } from '@dativa-lv/lx-ui';

import App from '@/App.vue';
import router from '@/router';
import lv from '@/locales/lv.json';
import events from '@/router/events';
import 'cropperjs/dist/cropper.css'; // TODO Sergejs

import '@dativa-lv/lx-ui/dist/styles/lx-pt-visvaris-social.css';
import '@dativa-lv/lx-ui/dist/styles/lx-buttons.css';
import '@dativa-lv/lx-ui/dist/styles/lx-day-input.css';
import '@dativa-lv/lx-ui/dist/styles/lx-shell-grid-public.css';
import '@dativa-lv/lx-ui/dist/bundles/lx-bt-viddis.css';

import '@/styles/style.css';
import VueDOMPurifyHTML from 'vue-dompurify-html';

const myApp = createApp(App);
myApp.use(createPinia());
events(router);
myApp.use(router);
myApp.use(VueDOMPurifyHTML);

myApp.use(
  createI18n({
    legacy: false,
    locale: 'lv',
    messages: {
      lv,
    },
  })
);

myApp.use(createLx, {
  systemId: 'viddis',
  authSessionKey: 'viddis-sessionkey',
  authUrl: window.config.authUrl,
  authClientId: 'viddis-auth',
  publicUrl: window.config.publicUrl,
});
myApp.mount('#app');
